"use strict";

/*Loading Spinner*/
(function (H) {

	H.wrap(H.Chart.prototype, 'showLoading', function (proceed) {
		var chart = this,
		    myLoading = chart.myLoading,
		    container = chart.options.loadingCnt || $(chart.container.parentNode);

		if(isDarkMode == true){$(".highcharts-background").attr("fill","rgb(35,35,35)")}

		if (!myLoading) {
			/* create loading div */
			myLoading = chart.myLoading = {
				cnt: $('<div class="mkspinner"></div>'),
				show: function show() {
						this.cnt.show();
						// $('.compareBtn').show()
						if (isFirstCall || !isUpdate) {
							$('.compareBtn').addClass('compareBtnActive')
							$('.superMenuBtn').hide()
							$('.iChart-menu-btn-download').hide()
							$('.iChart-menu-btn-export').hide()
						}
					},
					hide: function hide() {
						this.cnt.hide();
						$('.compareBtn').show()
						$('.eventsBtn').show()
						$('.fullscreenBtn').show()
						$('.superMenuBtn').css('display', 'flex')
						$('.compareBtn').removeClass('compareBtnActive')
						$('.iChart-menu-btn-download').show()
						$('.iChart-menu-btn-export').show()
				}
			};
			container.prepend(myLoading.cnt);
		}
		myLoading.show();
	});

	H.wrap(H.Chart.prototype, 'hideLoading', function (proceed) {
		var chart = this,
		    myLoading = chart.myLoading;

		if (myLoading) {
			myLoading.hide();
		}
	});
})(Highcharts);